function formatMuiErrorMessage(code) {
  let url = "https://mui.com/production-error/?code=" + code;
  for (let i = 1; i < arguments.length; i += 1)
    url += "&args[]=" + encodeURIComponent(arguments[i]);
  return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
}
export {
  formatMuiErrorMessage as default
};
//# sourceMappingURL=formatMuiErrorMessage.js.map
